import React from "react";
import errorIcon from "../img/error-page.png"


class ErrorBoundry extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {

            return (
                <><center>
                    <img style={{ width: '20%' }} src={errorIcon} alt="Error" />
                    <h2>Something went wrong 😢</h2>
                    <a href="/">Back to home</a>
                </center></>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundry;